// Project-specific helpers for adapting our string-based LatLng to
//  the Google Maps API's number-based LatLng.
//
// The Google Maps types themselves come from `@types/google.maps`
//  (transitively from `@react-google-maps/api`) and are available
//  as `google.maps.*` globally.
//
import { LatLngStr } from './stopTypes';

export const latLngNumberFromLatLngStr = (latLngStr: LatLngStr): google.maps.LatLngLiteral => ({
    lat: parseFloat(latLngStr.lat),
    lng: parseFloat(latLngStr.lng),
});

// Must be something like `${lat}, ${lng}`.
export const formatLatLangForDirections = ({ lat, lng }: LatLngStr): string => `${lat}, ${lng}`;
